<template>
  <section class="seccion blog-carrousel">
    <h2 v-if="title">BLOG</h2>
    <div class="columns slidex-wrap">
      <div
        class="column is-one-third"
        v-for="(slide, $index) in slidesComp"
        :key="`slidex-blog-${$index}`"
      >
        <card :content="slide" />
      </div>
    </div>
    <!-- <slick ref="slick-blog" :options="options">
    </slick> -->
    <!-- <div class="arrows">
      <img
        src="../assets/images/arrow-left.svg"
        :class="`arrows-prev arrows-prev-${idSlider}`"
        alt=""
      />
      <img
        src="../assets/images/arrow-right.svg"
        :class="`arrows-next arrows-next-${idSlider}`"
        alt=""
      />
    </div> -->
  </section>
</template>

<script>
import Card from "./Card";
// import Slick from "vue-slick";
import "../../node_modules/slick-carousel/slick/slick.css";
export default {
  name: "blogCarrousel",
  components: {
    Card
    // Slick
  },
  props: {
    title: {
      type: Boolean,
      default: false
    },
    idSlider: {
      type: String,
      default: "blog"
    }
  },
  data() {
    return {
      options: {
        infinite: false,
        dots: true,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        prevArrow: `.arrows-prev-${this.idSlider}`,
        nextArrow: `.arrows-next-${this.idSlider}`,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              infinite: true,
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },
      slides: [
        {
          img: require("../assets/images/placeholder-300x202.jpg"),
          text:
            "Cada vez más empresas migran su contabilidad asistemas en la nube",
          date: new Date(),
          id: "nueva-entrada"
        },
        {
          img: require("../assets/images/placeholder-300x202.jpg"),
          text:
            "Cada vez más empresas migran su contabilidad asistemas en la nube",
          date: new Date(),
          id: "nueva-entrada"
        },
        {
          img: require("../assets/images/placeholder-300x202.jpg"),
          text:
            "Cada ve más empresas migran su contabilidad asistemas en la nube",
          date: new Date(),
          id: "nueva-entrada"
        },
        {
          img: require("../assets/images/placeholder-300x202.jpg"),
          text:
            "Cada vez más empresas migran su contabilidad asistemas en la nube",
          date: new Date(),
          id: "nueva-entrada"
        }
      ]
    };
  },
  async created() {
    // this.$modal.show("loader-root");
    // await this.$store.dispatch("getPostList");
    // this.$modal.hide("loader-root");
  },
  computed: {
    slidesComp() {
      if (!this.$store.getters.postListGetter) return this.slides;
      return this.$store.getters.postListGetter;
    }
  },
  methods: {
    currentIndexFunc($e) {
      // console.log($e);
      // console.log("en currentIndexFunc");
      this.currentIndex = $e;
    }
  }
};
</script>

<style lang="scss"></style>

<style lang="scss" scoped>
@import "../assets/styles/general.scss";
@import "../../node_modules/slither-slider/plugin-dist/slither-slider.css";
.slither-slider {
  max-width: 1000px;
  margin: auto;
  width: 80%;
  @include desktop-large() {
    max-width: none;
  }
}
.blog-carrousel {
  margin: 1.5em auto 3em;
  position: relative;
  overflow: visible;
  width: 80%;
  max-width: 1500px;
  @include laptop() {
    margin: 3em auto 10em;
  }
  h2 {
    font-weight: normal;
    font-size: 1.2rem;
    font-family: "Geometos", sans-serif;
    @include tablet() {
      font-size: 2.8rem;
    }
    @include laptop() {
      font-size: 4em;
      margin-bottom: 1em;
    }
  }
  &__tabs {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-evenly;
    align-items: center;
    padding: 2rem 1rem;
    p {
      border-bottom: 5px solid transparent;
      transition: all 0.3s;
    }
    .current-module {
      border-bottom: 5px solid $primary;
    }
  }
  .slidex {
    padding: 3rem 1rem;
    z-index: 1;
    // max-width: 300px;
    width: 320px;
    margin: 0;
    &__text {
      text-align: start;
      h3 {
        color: $primary;
        font-size: 2.5rem;
        letter-spacing: 0.015em;
      }
      p {
        font-size: 2rem;
        letter-spacing: 0.015em;
      }
      .button {
        font-size: 1.5rem;
        font-weight: normal;
        letter-spacing: 0.015em;
      }
    }
    &__image {
      margin-left: auto;
    }
    @include desktop() {
      max-width: 350px;
    }
    @include desktop-large() {
      max-width: 400px;
    }
  }
}
.slidex-wrap {
  flex-wrap: wrap;
}
</style>
